export const getStatusBadgeColor = (status: string) => {
  switch (status) {
    case "paid":
      return "bg-green-100 text-green-800";
    case "scheduled":
      return "bg-blue-100 text-blue-800";
    case "unpaid":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

export const combineDateTime = (date: Date, time: string): Date => {
  const [hours, minutes] = time.split(':').map(Number);
  const combined = new Date(date);
  combined.setHours(hours, minutes);
  return combined;
};

export const defaultEmailTemplate = `
<h2>Invoice Reminder</h2>
<p>Dear valued client,</p>
<p>This is a reminder about the invoice due on [Due Date].</p>
<p>Thank you for your business!</p>
`;